import { useQuery } from '@tanstack/react-query';
import { Organization } from '../../../types/organization';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchOrganization = async () => {
  const response = await CustomAxios.get<Organization>(`organizations/current`);
  const { data } = response;
  return data;
};

interface UseGetOrganizationByIdProps {
  enabled?: boolean;
}
export function useGetCurrentOrganization({ enabled = true }: UseGetOrganizationByIdProps) {
  const query = useQuery({
    enabled,
    queryKey: [queryKeys.currentOrganization],
    queryFn: fetchOrganization,
  });

  return query;
}
